import { MarketStatus, MatchPredictionStatItemDto } from '@sportspredict/shared';
import type { ProbabilityMarket } from '../types/probability-event.types';

export function applyMarketUpdate(
	prev: ProbabilityMarket[],
	market: ProbabilityMarket
): ProbabilityMarket[] {
	const idx = prev.findIndex((m) => m.id === market.id);
	if (idx >= 0) {
		return market.status === MarketStatus.Open
			? prev.map((m) => (m.id === market.id ? { ...m, ...market } : m))
			: prev.filter((m) => m.id !== market.id);
	}
	return market.status === MarketStatus.Open ? [...prev, market] : prev;
}

export const getMarketClosingDate = (market: ProbabilityMarket) => {
	const rawDate = market?.closing_date;
	if (!rawDate) return null;

	const date = new Date(rawDate);
	return Number.isNaN(date.getTime()) ? null : date;
};

export function getTopMarketByRelativeBrierScore(
	markets?: MatchPredictionStatItemDto[]
): (MatchPredictionStatItemDto & { rbs: number }) | null {
	if (!markets || markets.length === 0) return null;

	const marketsWithRbs = markets.map((m) => ({
		...m,
		rbs: m.relative_brier_score ?? 0,
	}));

	return marketsWithRbs.reduce((best, current) => (current.rbs > best.rbs ? current : best));
}

export function getForecastText(user: number, crowd: number, relativeBrierScore: number): string {
	if (relativeBrierScore === 0) {
		return `Your ${user}% forecast tied with the crowd average`;
	}
	if (relativeBrierScore > 0) {
		return `Your ${user}% forecast beat the crowd average of ${crowd}%`;
	}
	return `Your ${user}% forecast is below the crowd average of ${crowd}%`;
}
